import React from 'react'
import BookItem from './BookItem';

const BooksList = ({books, renderingList, language}) => {
    return (
        <section className="clearfix">
            {renderingList && renderingList.map((el)=>{
                return (
                    <BookItem key={el} book={books[el]} language={language} />
                )
            })}
        </section>
    )
}

export default BooksList
